import { useState } from 'react';
import HeroHeading from '../components/GetStarted/HeroHeading';
import Questions from '../components/Common/Questions';
import HistoryCard from '../components/History/HistoryCard';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { botOperationServices } from '../services/botOperations';
import BotInfoForm from '../components/GetStarted/BotInfoForm';
import HistoryCardSkeleton from '../components/Skeleton/HistoryCardSkeleton';
import { Apps } from 'constants/global';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { Link } from 'react-router-dom';
import PromotionalBanner from '../components/Common/PromotionalBanner';
import lightBg from '../assets/lightBg.svg';
import darkBg from '../assets/darkBg.svg';

const BotHistory = () => {
  const [showForm, setShowForm] = useState(false);
  const queryClient = useQueryClient();
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const { isDarkMode } = useSelector((state: RootState) => state.theme);

  const backgroundStyle = {
    backgroundImage: `url(${isDarkMode ? darkBg : lightBg})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  };

  const loginLinks = (
    <>
      {' '}<Link to="/auth/login" className="underline font-semibold">login</Link> or <Link to="/auth/register" className="underline font-semibold">sign up</Link> to create your new bot
    </>
  );

  const { data: allBots, isLoading } = useQuery({
    queryKey: ['bot-history'],
    queryFn: botOperationServices.getAllBots,
    enabled: isAuthenticated,
  });

  const handleNewBotAdded = () => {
    queryClient.invalidateQueries({ queryKey: ['bot-history'] });
    setShowForm(false);
  };

  return (
    <section className="w-full text-text-primary rounded-md">
      {!isAuthenticated && (
        <PromotionalBanner 
          message="Please"
          actionComponent={loginLinks}
          dismissible={true}
          textSize="lg"
        />
      )}
      
      {/* <div className="w-full bg-black px-4 py-3 flex justify-between items-center">
          <p className="text-[14px] font-normal text-white text-center w-full">
          Need help? Scroll down to our FAQs for detailed answers and guidance on using Bot Builder.
        </p>
      </div> */}
      
      <div className="flex flex-col" style={backgroundStyle}>
        <div className="w-full rounded-t-md pt-10">
          <HeroHeading />
          {isAuthenticated && showForm && (
            <BotInfoForm
              setShowForm={setShowForm}
              onBotCreated={handleNewBotAdded}
              isAuthenticated={isAuthenticated}
            />
          )}
        </div>
        {!showForm && (
          <div className="p-5 md:p-16 bg-white dark:bg-[#202020] rounded-md shadow-sm mx-4 mb-8 dark:text-white">
            {!isAuthenticated ? (
              <div className="flex flex-col items-center justify-center py-10">
                <p className="text-lg mb-4">You need to be logged in to view your bots.</p>
                <div className="flex gap-4">
                  <Link 
                    to="/auth/login" 
                    className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
                  >
                    Login
                  </Link>
                  <Link 
                    to="/auth/register" 
                    className="px-4 py-2 bg-secondary text-primary-600 rounded-md hover:bg-secondary/80 transition-colors"
                  >
                    Sign Up
                  </Link>
                </div>
              </div>
            ) : isLoading ? (
              <HistoryCardSkeleton />
            ) : (
              allBots && (
                <HistoryCard
                  setShowForm={setShowForm}
                  bots={allBots?.data.bots}
                />
              )
            )}
          </div>
        )}
        <Questions appType={Apps.BOT_BUILDER} />
      </div>
    </section>
  );
};

export default BotHistory;
